export default "__VITE_ASSET__lELAhx1d__"